<template>
    <product title="Køl / Frys">
        <div slot="description">
            <p>
                P. Pedersen &amp; Søn transporterer temperaturkontrollerede køl- og frostvarer med temperaturer ned til -30 grader.
            </p>
            <p>
                P. Pedersen &amp; Søn har certificering inden for fødevaresikkerhed og fødevarehygiejne.
            </p>
            <p>
                <div class="btn-holder alt">
                    <a href="/static/images/kontrolrapport.pdf"
                        rel="noopener"
                        target="_blank"
                        class="btn-primary text-center text-uppercase active md-round">
                        <i class="fa fa-file-o fa-fw"></i> Se certifikat
                    </a>
                    Certifikatet kan også findes på Fødevarestyrelsens hjemmeside. <!--<a rel="noopener" target="_blank" href="https://www.foedevarestyrelsen.dk/Nyheder/Aktuelt/Sider/Nyheder_2017/Skal_dine_f%C3%B8devarer_skifte_transport%C3%B8r.aspx">her</a>.-->
                </div>
            </p>
            <p>
                <img class="product-image" src="/static/images/koel_frys.jpg" />
            </p>
        </div>
    </product>
</template>
<script>
    import Product from '../../../components/elements/product'
    export default {
        name: 'Koel',
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// koel.vue?b5dd427a